
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useAvatarBackgroundList } from '@/modules/avatar/background/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useAvatarBackgroundList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Boolean, label: 'Is published', key: 'isPublished' },
                { type: TableColumnType.Boolean, label: 'Is new', key: 'isNew' },
                { type: TableColumnType.Boolean, label: 'Is special', key: 'isSpecial' },
                { type: TableColumnType.Boolean, label: 'Is default', key: 'isDefault' },
                { type: TableColumnType.Text, label: 'Total sale', key: 'totalSale' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.BACKGROUND.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, query, list, total, fetchList, actions, ROUTE_NAME_AVATAR };
    }
});
